import Documents, { DocumentOptionalColumns } from "components/documents/Documents";
import { usePermission } from "components/utils/Permission";
import { Product } from "view/products/utils/product.types";
import { DocumentEntity, DocumentType } from "__generated__/enums";

const ProductDocuments = ({ product }: { product: Pick<Product, "id" | "name"> }) => {

	const { isAdmin, isCompanyUser, isMasterdata, isMainUserLimited } = usePermission();

	return (
		<div>
			<Documents
				canCreate={isAdmin || isCompanyUser || isMasterdata || isMainUserLimited}
				canDelete={isAdmin || isCompanyUser || isMasterdata || isMainUserLimited}
				entities={[ {
					id: product.id,
					name: product.name,
					type: DocumentEntity.Product,
				} ]}
				showOptionalColumns={[
					DocumentOptionalColumns.DocumentType,
					DocumentOptionalColumns.IssuedAt,
					DocumentOptionalColumns.ValidUntil,
				]}
				documentTypeOptions={[
					DocumentType.Other,
					DocumentType.Sds,
				]} />
		</div>
	);
};

export default ProductDocuments;
